import { useSyncExternalStore } from 'react'
import { SidebarState } from '../../../types/state'
import { SidebarEvent } from '../../constants/enums'
import { SIDEBAR } from '../../state'
import { pubSubSidebar } from '../../state/pubSub'

const getSidebarSelector =
    <T extends keyof SidebarState>(key: T) =>
    () =>
        SIDEBAR.state[key]
const subSidebar = (callback: () => void) =>
    pubSubSidebar.on(SidebarEvent.STATE, callback)

export const useSidebarSelector = <T extends keyof SidebarState>(
    key: T,
): SidebarState[T] => {
    const showSidebar = useSyncExternalStore(
        subSidebar,
        getSidebarSelector(key),
        getSidebarSelector(key),
    )

    return showSidebar
}
